import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(({ palette }) => ({
    text: {
        marginBottom: '-3px',
        fontWeight: 600,
        color: palette.type === 'light' ? palette.grey['700'] : palette.accent3Color,
    },
}));
